import {
  prePay, pay, preRefund, refund, getPayRecord, getPayDetail, getInvoiceList, getRefundItem, getRefundItemOld, createRefundTask, editRefundTaskDetail, queryRefundTaskList,
  getRefundTask, refundRetry, changeTaskDetail, prePayRecords, payCallback, getOrderPayNum, cancelPayingStatus, refundCallback, createRefundTaskBatch, createStandbyRefundTask, standbyPreRefund
} from '@/api/pay'
import { isNull } from '@/utils/validateBase'
class payDTO {
  /**
   * 预支付
   * obj 预支付参数
   */
  static prePay(preObj) {
    return new Promise((resolve, reject) => {
      prePay(preObj).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })

  }

  /**
   * 支付
   */
  static pay(payObj) {
    return new Promise((resolve, reject) => {
      pay(payObj).then(payRes => {
        resolve(payRes)
      }).catch(err => {
        reject(err)
      })
    })
  }

  /**
   * 预支付+支付
   * obj 支付参数
   * @param {*} obj 
   */
  static payFun(preObj) {
    return new Promise((resolve, reject) => {
      prePay(preObj).then(res => {
        if (res.code == 200) {
          let payObj = {
            orderPayNumber: res.data.orderPayNumber,
            attach: isNull(preObj.attach) ? {} : preObj.attach,
          }
          pay(payObj).then(payRes => {
            let request = {
              code: payRes.code,
              data: { ...res.data, ...payRes.data }
            }
            resolve(request)
          }).catch(err => {
            reject(err)
          })
        } else {
          reject(res)
        }
      }).catch(err => {
        reject(err)
      })

    })
  }

  /**
   * 预退款
   */
  static preRefund(preObj) {
    return new Promise((resolve, reject) => {
      preRefund(preObj).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  }

  /**
   * 退款
   */
  static refund(refundObj) {
    return new Promise((resolve, reject) => {
      refund(refundObj).then(refundRes => {
        resolve(refundRes)
      }).catch(err => {
        reject(err)
      })
    })
  }

  /**
   * 预退款+退款
   */
  static refundFun(preObj) {
    return new Promise((resolve, reject) => {
      preRefund(preObj).then(preRes => {
        if (preRes.code == 200) {
          refund({ refundNumber: preRes.data.refundNumber }).then(res => {
            let request = {
              code: res.code,
              data: { ...preRes.data, ...res.data }
            }
            resolve(request)
          }).catch(err => {
            reject(err)
          })
        } else {
          reject()
        }
      }).catch(err => {
        reject(err)
      })
    })
  }

  /**
   * 查询支付记录
   * params 订单编号
   */
  static getPayRecord(params) {
    return new Promise((resolve, reject) => {
      getPayRecord(params).then(res => {
        resolve(res)
      })
    })
  }
  /**
   * 查询收费详情
   * params 订单编号
   */
  static getPayDetail(params) {
    return new Promise((resolve, reject) => {
      getPayDetail(params).then(res => {
        resolve(res)
      })
    })
  }
  /**
   * 查询顶顶那发票详情
   * params 订单编号
   */
  static getInvoiceList(params) {
    return new Promise((resolve, reject) => {
      getInvoiceList(params).then(res => {
        resolve(res)
      })
    })
  }

  /**
   * 查询退款项目
   * params 就诊id orderType 类型 0挂号 4划价
   */
  static getRefundItem(params) {
    return new Promise((resolve, reject) => {
      getRefundItem(params).then(res => {
        resolve(res)
      })
    })
  }
  static getRefundItemOld(params) {
    return new Promise((resolve, reject) => {
      getRefundItemOld(params).then(res => {
        resolve(res)
      })
    })
  }

  /**
   * 创建退款单
   * params 就诊id orderType 类型 0挂号 4划价
   */
  static createRefundTask(params) {
    return new Promise((resolve, reject) => {
      createRefundTask(params).then(res => {
        resolve(res)
      })
    })
  }

  /**
   * 创建退款单
   * params 就诊id orderType 类型 0挂号 4划价
   */
  static createRefundTaskBatch(params) {
    return new Promise((resolve, reject) => {
      createRefundTaskBatch(params).then(res => {
        resolve(res)
      })
    })
  }

  /**
   * 编辑退款单
   * params 就诊id orderType 类型 0挂号 4划价
   */
  static editRefundTaskDetail(params) {
    return new Promise((resolve, reject) => {
      editRefundTaskDetail(params).then(res => {
        resolve(res)
      }).catch(() => {
        resolve({ code: 500 })
      })
    })
  }
  /**
   * 查询退款单列表
   * params 分页信息 搜索条件
   */
  static queryRefundTaskList(params) {
    return new Promise((resolve, reject) => {
      queryRefundTaskList(params).then(res => {
        resolve(res)
      })
    })
  }
  /**
   * 查询退款单详情
   */
  static getRefundTask(params) {
    return new Promise((resolve, reject) => {
      getRefundTask(params).then(res => {
        resolve(res)
      })
    })
  }
  /**
   * 退款重试
   */
  static refundRetry(params) {
    return new Promise((resolve, reject) => {
      refundRetry(params).then(res => {
        resolve(res)
      })
    })
  }
  /**
   * 更换退款方式
   */
  static changeTaskDetail(params) {
    return new Promise((resolve, reject) => {
      changeTaskDetail(params).then(res => {
        resolve(res)
      })
    })
  }
  /**
   * 查询预支付记录
   */
  static prePayRecords(params) {
    return new Promise((resolve, reject) => {
      prePayRecords(params).then(res => {
        resolve(res)
      })
    })
  }
  /**
   * 支付完成
   */
  static payCallback(params) {
    return new Promise((resolve, reject) => {
      payCallback(params).then(res => {
        resolve(res)
      })
    })
  }
  /**
   * 获取支付中的支付单号
   */
  static getOrderPayNum(params) {
    return new Promise((resolve, reject) => {
      getOrderPayNum(params).then(res => {
        resolve(res)
      })
    })
  }
  /**
   * 取消支付中状态
   */
  static cancelPayingStatus(params) {
    return new Promise((resolve, reject) => {
      cancelPayingStatus(params).then(res => {
        resolve(res)
      })
    })
  }
  /**
   * 退款完成
   */
  static refundCallback(params) {
    return new Promise((resolve, reject) => {
      refundCallback(params).then(res => {
        resolve(res)
      })
    }).catch(err => {
      reject(err)
    })
  }

  /**
   * 候补退款
   */
  static standbyRefund(preParams) {
    return new Promise((resolve, reject) => {
      standbyPreRefund(preParams).then(preRes => {
        resolve(preRes)
      }).catch(() => {
        resolve({ code: 500 })
      })
    })
  }
}


export { payDTO }